import React, { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useReapitConnect } from '@reapit/connect-session'
import { TopBar as ReapitTopBar } from '@reapit/elements/core/top-bar'
import { Menu } from '@reapit/elements/core/menu'
import { reapitConnectBrowserSession } from '../../reapit-connect-session'
import { getAbbreviation } from '@reapitform/utils'

export const Topbar: React.FC = () => {
  const { connectSession, connectLogoutRedirect } = useReapitConnect(reapitConnectBrowserSession)
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const userName = useMemo(
    () => getAbbreviation(connectSession?.loginIdentity.name || ''),
    [connectSession?.loginIdentity.name],
  )

  const handleNavigate = (path: string) => (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    navigate(path)
  }

  return (
    <ReapitTopBar
      logo={<ReapitTopBar.BrandLogo appName="Reapit Forms" onClick={() => navigate('/')} />}
      mainNav={
        <ReapitTopBar.MainNav>
          <ReapitTopBar.MainNav.Item
            aria-current={pathname === '/' ? 'page' : false}
            href="/"
            onClick={handleNavigate('/')}
          >
            Dashboard
          </ReapitTopBar.MainNav.Item>
          <ReapitTopBar.MainNav.Item
            aria-current={pathname.includes('/forms') ? 'page' : false}
            href="/forms"
            onClick={handleNavigate('/forms')}
          >
            Form Builder
          </ReapitTopBar.MainNav.Item>
        </ReapitTopBar.MainNav>
      }
      avatar={
        <ReapitTopBar.AvatarMenu initials={userName}>
          <Menu.Item key="logout" onClick={() => connectLogoutRedirect()}>
            Logout
          </Menu.Item>
        </ReapitTopBar.AvatarMenu>
      }
    />
  )
}

export default Topbar
